import Routes from "../router/Routes";
import "../assets/css/style.css";
import { Toaster } from "react-hot-toast";

function App() {
  return<>
  <Routes />
  <Toaster position="top-center" reverseOrder={false} />
  </> 
}

export default App;
